'use strict';

// パンくずリストが画面幅に収まらない場合各文字数を確認し、7文字になるまで省略する
function readyBreadcrumb() {
    const row = document.getElementById('breadcrumb-row');
    if (!row) return;

    // .breadcrumb-text だけを対象にする
    const items = Array.from(row.querySelectorAll('.breadcrumb-text'))
        .map((el) => {
            const full = el.textContent; // 元々の文字列
            const len = full.length;

            return {
                el,
                full,
                currentLength: len,
                minLength: len >= 8 ? 7 : len, // 7文字以下は固定
            };
        })
        // 8文字以上のみ省略対象
        .filter((item) => item.full.length >= 8);

    // 文字数の省略を行う
    function render(item) {
        if (item.currentLength < item.full.length) {
            // 省略されている場合は省略記号を付ける
            item.el.textContent = item.full.slice(0, item.currentLength) + '…';
        } else {
            item.el.textContent = item.full;
        }
    }

    // 省略していない状態に戻す
    function reset() {
        items.forEach((item) => {
            item.currentLength = item.full.length;
            item.el.textContent = item.full;
        });
    }

    // 画面幅に収めるように優先順位ごとに省略する
    function applyEllipsis() {
        // 初期化
        reset();

        if (row.scrollWidth <= row.clientWidth) return;

        // 画面幅に収まるまで繰り返す
        while (row.scrollWidth > row.clientWidth) {
            // 現在いちばん長い文字列を探す（省略済み含む）
            const target = items
                .filter((i) => i.currentLength > i.minLength)
                .sort((a, b) => b.currentLength - a.currentLength)[0];

            // これ以上削れない場合終了
            if (!target) break;

            // 1文字削る
            target.currentLength -= 1;
            render(target);
        }
    }

    // 初期表示での省略実行
    applyEllipsis();
    // resizeでのapplyEllipsis関数呼び出しを設定
    window.addEventListener('resize', applyEllipsis);
}

module.exports = {
    readyBreadcrumb,
};
